import { Guid } from "guid-typescript";
import { IMessage } from "../../../IMessage";

//Generated code, do not modify

export class GetEventDayProgramQuery implements IMessage {
    id!: Guid;

    public constructor(init?: Partial<GetEventDayProgramQuery>) {
        Object.assign(this, init);
    }

    getMethod = () => "GET";

    getUrl = () => `/admin/event-days/${this.id.toString()}/program`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}